import axios from "axios";
import { BASE_URL_STRING } from "./axios";

export const BASE_URL = BASE_URL_STRING;
export const EndPoints = {
  createAssessment: "create",
  searchAssessment: "search",
  toggleAssessmentStatus: "toggle-status",
  getAssessmentDetails: (id) => `id/${id}`,
  updateCore: (id) => `${id}/core`,
  updateQuestions: (id) => `${id}/questions/save`,
  getResultDetails: (assessmentId, submissionId) =>
    `${assessmentId}/submissions/${submissionId}`,
  getResults: "dashboard/results",
  getAssessmentResults: (id) => `dashboard/${id}/results`,
};

export const createAssessmentsAPIEndpoint = (endpoint) => {
  let url = BASE_URL + "v1/assessments/" + endpoint + "/";
  const token = sessionStorage.getItem("token");
  return {
    fetch: (options) =>
      axios.get(url, {
        ...options,
        headers: { Authorization: `Bearer ${token}` },
      }),


    fetchById: (id) =>
      axios.get(url + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    post: (newRecord) => axios.post(url, newRecord),

    postWithToken: (newRecord) =>
      axios.post(url, newRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    postById: (id, newRecord) =>
      axios.post(url + id, newRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    put: (updatedRecord) =>
      axios.put(url, updatedRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    putById: (id, updatedRecord) =>
      axios.put(url + id, updatedRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    delete: (id) =>
      axios.delete(url + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
  };
};

